import { useContext } from "react";
import { ArrMrrContext } from "./context";

export const useArrMrr = () => {
  const context = useContext(ArrMrrContext);
  if (context === undefined) {
    throw new Error("useArrMrr must be used within an ArrMrrProvider");
  }
  return context;
};
